<template>
  <v-content>
    <v-container>
      <v-alert class="mt-8" type="info" color="primary" v-if="false">
        Missing engine hours sensor
      </v-alert>
      <services-upcoming-list
        ref="upcomingList"
        :title="maitenanceTitle"
        :headers="maitenanceHeaders"
        :data="maitenanceData"
        :response="upcomingResponse"
        :loading="loadingMaintenance"
        @task="handlePreview"
        @reload="handleReload"
        @preview="openServiceDetails($event, 'maintenance')"
        @boat="boat = $event"
        @edit="openServiceDetails($event, 'edit')"
        @mounted="handleMount('upcomingList')"
      >
        <template v-slot:alert>
          <v-alert type="warning" color="warning" v-if="showDeliveryDateAlert">
            {{
              $t(
                "tasks.service.deliveryDateOfTheBoatIsUndefinedMaintenanceForecastsForTimeBasedProtocolsWontBeAvailable"
              )
            }}
          </v-alert>
        </template>
      </services-upcoming-list>
      <services-history-list
        ref="historyList"
        :title="historyTitle"
        :headers="historyHeaders"
        :data="historyData"
        :response="historyResponse"
        :loading="loadingHistory"
        @reload="loadHistory"
        @preview="openServiceDetails($event, 'history')"
        @hook:mounted="handleMount('historyList')"
      />
    </v-container>
    <details-side-bar
      v-if="serviceDetailsDialog.active"
      :active="serviceDetailsDialog.active"
      :permanent="serviceDetailsDialog.permanent"
      @close="closeServiceDetailsDialog"
    >
      <template v-slot:button-close>
        <v-btn text color="primary" @click="closeServiceDetailsDialog">
          <v-icon class="mr-2 edit--hover"> mdi-arrow-left-circle </v-icon>
          {{ $t("tasks.service.back") }}
        </v-btn>

        <v-btn
          text
          color="primary"
          v-if="
            serviceDetailsDialog.details.crm_internal_task !== null &&
            serviceDetailsDialog.action === 'maintenance'
          "
          @click="openTask(serviceDetailsDialog.details.crm_internal_task.uuid)"
        >
          <v-icon class="mr-2 edit--hover"> mdi-link </v-icon>
          {{ $t("tasks.service.openTask") }}
        </v-btn></template
      >
      <!-- <template v-slot:title>Maintenance</template> -->
      <template v-slot:content>
        <service-details
          v-if="
            serviceDetailsDialog.active &&
            serviceDetailsDialog.action === 'maintenance'
          "
          :dialog="serviceDetailsDialog"
        ></service-details>

        <service-history-details
          v-if="
            serviceDetailsDialog.active &&
            serviceDetailsDialog.action === 'history'
          "
          :dialog="serviceDetailsDialog"
        ></service-history-details>

        <service-edit
          v-if="
            serviceDetailsDialog.active &&
            serviceDetailsDialog.action === 'edit'
          "
          :dialog="serviceDetailsDialog"
          @close="closeServiceDetailsDialog('edit')"
        ></service-edit>
        <div></div>
      </template>
    </details-side-bar>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import ServicesUpcomingList from "@/components/lists/ServicesUpcomingList.vue";
import ServicesHistoryList from "@/components/lists/ServicesHistoryList.vue";
import ServiceDetails from "@/components/service/ServiceDetails";
import ServiceHistoryDetails from "@/components/service/ServiceHistoryDetails";
import ServiceEdit from "@/components/service/ServiceEdit";
import DetailsSideBar from "@/components/general/DetailsSideBar";

export default {
  components: {
    ServicesHistoryList,
    ServiceHistoryDetails,
    ServiceDetails,
    DetailsSideBar,
    ServiceEdit,
    ServicesUpcomingList,
  },
  data: () => ({
    mounted: {
      historyList: { mounted: false, refs: "historyList" },
      upcomingList: { mounted: false, refs: "upcomingList" },
      root: { mounted: false, refs: null },
    },
    maitenanceHeaders: [],
    historyHeaders: [],
    maitenanceData: [],
    historyData: [],
    sort: "name",
    maitenanceTitle: "Maintenance",
    historyTitle: "History",
    deleteDialog: false,
    boat: null,
    boatName: null,
    loadingMaintenance: true,
    loadingHistory: false,
    historyResponse: null,
    upcomingResponse: null,
    forceRefreshServiceDetails: 0,
    serviceDetailsDialog: {
      permanent: false,
      active: false,
      details: null,
      action: null,
      boat: null,
    },
    showDeliveryDateAlert: false,
  }),
  created() {
    this.setInitalData();
  },

  mounted() {
    //NOTE: this is here to prevent multiple API calls to the same function. To gether all the parameters from the different components.
    this.handleMount("root");
  },

  computed: {},

  methods: {
    handleMount(componentName) {
      if (!this.mounted.hasOwnProperty(componentName)) {
        console.error("BOATS:component name does not exists", componentName);
        return;
      }

      this.mounted[componentName] = {
        ...this.mounted[componentName],
        mounted: true,
      };

      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.loadTasks();
        this.loadHistory();
      }
    },
    setInitalData() {
      this.setHeaders();
      this.maitenanceTitle = this.$t("tasks.service.maintenance");
      this.historyTitle = this.$t("tasks.service.history");
    },
    setHeaders() {
      this.maitenanceHeaders = [
        // {
        //   text: "",
        //   align: "left",
        //   value: "engine_hours_available",
        //   sortable: false,
        //   canEdit: false,
        //   index: 0,
        // },
        {
          text: "",
          align: "left",
          value: "engine_hours_available",
          sortable: false,
          canEdit: false,
          index: 0,
        },
        {
          text: this.$t("tasks.service.boat"),
          align: "left",
          value: "crm_boat",
          sortable: false,
          canEdit: false,
          index: 0,
        },
        {
          text: this.$t("tasks.service.part"),
          align: "left",
          value: "crm_boat_item",
          sortable: false,
          canEdit: false,
          index: 1,
        },
        {
          text: this.$t("tasks.service.taskName"),
          align: "left",
          value: "crm_service",
          sortable: false,
          canEdit: false,
          index: 2,
        },
        {
          text: this.$t("tasks.service.status"),
          align: "center",
          value: "is_critical",
          sortable: false,
          canEdit: false,
          index: 3,
        },
        {
          text: this.$t("tasks.service.engineHours"),
          align: "left",
          value: "should_be_engine_seconds_before",
          sortable: false,
          canEdit: true,
          index: 4,
        },
        {
          text: this.$t("tasks.service.dueTime"),
          align: "left",
          value: "should_be_done_before",
          sortable: false,
          canEdit: true,
          index: 5,
        },
        {
          text: this.$t("tasks.service.taskStatus"),
          align: "center",
          value: "crm_internal_task",
          sortable: false,
          canEdit: false,
          index: 6,
        },
        {
          text: "",
          align: "right",
          value: "action",
          sortable: false,
          canEdit: true,
          index: 7,
        },
      ];

      this.historyHeaders = [
        {
          text: this.$t("tasks.service.author"),
          align: "left",
          value: "generated_by",
          sortable: false,
          canEdit: false,
          index: 3,
        },
        // {
        //   text: this.$t("tasks.service.title"),
        //   align: "left",
        //   value: "title",
        //   sortable: false,
        //   canEdit: false,
        //   index: 4,
        // },
        {
          text: this.$t("tasks.service.completedTasks"),
          align: "left",
          value: "notes",
          sortable: false,
          canEdit: false,
          index: 0,
        },
        {
          text: this.$t("tasks.service.engineHours"),
          align: "left",
          value: "engine_hours",
          sortable: false,
          canEdit: true,
          index: 1,
        },
        {
          text: this.$t("tasks.service.completedOn"),
          align: "left",
          value: "completion_date",
          sortable: false,
          canEdit: true,
          index: 2,
        },

        {
          text: "",
          align: "right",
          value: "action",
          sortable: false,
          canEdit: true,
          index: 7,
        },
      ].sort((a, b) => (a.index > b.index ? 1 : b.index > a.index ? -1 : 0));
    },
    setDoneTemplate() {
      return [
        {
          text: this.$t("tasks.service.engineHours"),
          align: "left",
          value: "doneMileage",
          canEdit: true,
          sortable: false,
          index: 4,
        },
        {
          text: this.$t("tasks.service.completedOn"),
          align: "left",
          value: "doneTime",
          canEdit: true,
          sortable: false,
          index: 5,
        },
      ];
    },
    setOverdueTemplate() {
      return [
        {
          text: this.$t("tasks.service.engineHours"),
          align: "left",
          value: "overdueMileage",
          canEdit: true,
          sortable: false,
          index: 4,
        },
        {
          text: this.$t("tasks.service.dueSince"),
          align: "left",
          value: "overdueTime",
          canEdit: true,
          sortable: false,
          index: 5,
        },
        {
          text: "",
          align: "right",
          value: "action",
          sortable: false,
          canEdit: true,
          index: 7,
        },
      ];
    },
    openTask(uuid) {
      this.$router.push({
        name: "tasksDetails",
        params: { id: uuid },
      });
    },
    handleReload(event) {
      this.loadTasks();
      this.loadHistory();
    },
    handlePreview(uuid) {
      this.$router.push({
        name: "tasksDetails",
        params: { id: uuid },
      });
    },
    openServiceDetails(event, action) {
      this.serviceDetailsDialog = {
        permanent: !!(action === "edit"),
        active: true,
        details: event,
        action: action,
        boat: this.boat.uuid,
      };
    },
    closeServiceDetailsDialog(action) {
      if (action === "edit") {
        this.loadTasks();
        this.loadHistory();
      }

      this.serviceDetailsDialog = {
        permanent: false,
        active: false,
        details: null,
        action: null,
        boat: null,
      };
    },
    computeUpcomingHeaders() {
      if (this.$refs.upcomingList.query.service_status === "overdue") {
        this.maitenanceHeaders = this.maitenanceHeaders.filter(
          (element) => !element.canEdit
        );
        this.maitenanceHeaders = [
          ...this.maitenanceHeaders,
          ...this.setOverdueTemplate(),
        ].sort((a, b) => (a.index > b.index ? 1 : b.index > a.index ? -1 : 0));
      } else if (this.$refs.upcomingList.query.service_status === "complete") {
        this.maitenanceHeaders = this.maitenanceHeaders.filter(
          (element) => !element.canEdit
        );
        this.maitenanceHeaders = [
          ...this.maitenanceHeaders,
          ...this.setDoneTemplate(),
        ].sort((a, b) => (a.index > b.index ? 1 : b.index > a.index ? -1 : 0));
      } else {
        this.setHeaders();
      }
    },
    loadTasks() {
      let params = {};

      params = {
        ...params,
        ...this.$refs.upcomingList.query,
      };

      this.$router.replace({
        name: this.$route.name,
        query: params,
      });
      this.loadingMaintenance = true;
      this.maitenanceData = [];
      api.getServiceList(params).then((resp) => {
        this.computeUpcomingHeaders();
        this.showDeliveryDateAlert =
          this.boat.delivery_date === null &&
          this.boat.delivery_date_to_customer === null;
        this.upcomingResponse = resp.data;
        this.maitenanceData = resp.data.results.map((element) => {
          return {
            ...element,
            icon: "mdi-calendar-plus",
          };
        });
        this.loadingMaintenance = false;
      });
    },
    loadHistory() {
      let params = {};

      params = {
        ...params,
        ...this.$refs.historyList.query,
      };

      this.loadingHistory = true;
      this.historyData = [];

      api
        .getServiceLogHistory(
          this.$refs.upcomingList.query.crm_boat_uuid,
          params
        )
        .then((resp) => {
          this.historyResponse = resp.data;
          this.historyData = resp.data.results;
          this.loadingHistory = false;
        });
    },
  },
};
</script>
